import React from 'react';
import { View, TouchableOpacity, Text } from 'react-native';
import { DesktopTableFilters } from '@/components/common/admin/desktop/dataTable/DesktopTableFilters';
import { ADMIN_COLORS } from '@/constants/admin';
import { IColumnConfig, IFilterModel, ISortModel } from '@/types/admin/dataTable';

export interface TasksFiltersHeaderDesktopProps<T> {
  columns: IColumnConfig<T>[];
  searchQuery: string;
  onSearchChange: (q: string) => void;
  filterModel: IFilterModel;
  onFilterChange: (m: IFilterModel) => void;
  sortModel: ISortModel[];
  onSortChange: (s: ISortModel[]) => void;
  headerRight?: React.ReactNode;
  showClearFilters?: boolean;
  onClearFilters?: () => void;
}

export function TasksFiltersHeaderDesktop<T>({
  columns,
  searchQuery,
  onSearchChange,
  filterModel,
  onFilterChange,
  sortModel,
  onSortChange,
  headerRight,
  showClearFilters,
  onClearFilters,
}: TasksFiltersHeaderDesktopProps<T>) {
  return (
    <View>
      <DesktopTableFilters
        columns={columns}
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        filterModel={filterModel}
        onFilterChange={onFilterChange}
        sortModel={sortModel}
        onSortChange={onSortChange}
        headerRight={(
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
            {headerRight}
            {showClearFilters && (
              <TouchableOpacity
                onPress={onClearFilters}
                style={{
                  borderWidth: 1,
                  borderColor: ADMIN_COLORS.BORDER,
                  backgroundColor: 'transparent',
                  paddingHorizontal: 10,
                  paddingVertical: 6,
                  borderRadius: 8,
                }}
              >
                <Text style={{ color: ADMIN_COLORS.TEXT_SECONDARY, fontSize: 12 }}>Clear Filters</Text>
              </TouchableOpacity>
            )}
          </View>
        )}
      />
    </View>
  );
}


